export const variacao = (value_1: number, value_2: number): number => {
  const sub = value_1;
  const result = ((value_2 - sub) / sub) * 100;
  return Math.abs(result);
};
